import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import ButtonSecondary from "../../buttons/ButtonSecondary/ButtonSecondary";
import { MinecraftIcon } from "../../icons/microsoft";

export const SignUpWithMicrosoft = () => {
  const [loading, setLoading] = useState(false);
  const { loginWithMicrosoft } = useAuth();

  const handleMicrosoftLogin = async () => {
    setLoading(true);
    loginWithMicrosoft()
      .then(async () => {
        // Note: Microsoft login redirects to external URL,
        // so this code won't execute. Redirect handled by callback page.
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <ButtonSecondary
      variant="white"
      size="lg"
      className="w-full my-4"
      loading={loading}
      text={"Continue with Minecraft"}
      onClick={handleMicrosoftLogin}
      icon={<MinecraftIcon />}
    />
  );
};
